import { BlockType } from "app/components/block-overlay/types";

interface BlockConfigType {
    header: string;
    content: string;
}
export const BLOCK_CONFIGS_BY_TYPE: Record<BlockType, BlockConfigType> = {
    "ad-blocker": {
        header: "Error:",
        content: "Could not download required scripts. Please update your browser or turn off ad blocker to continue to watch."
    },
    "content-not-allowed": {
        header: "Error:",
        content: "This content is unavailable due to rights restrictions."
    },
    "unknown-location": {
        header: "Error:",
        content: "Could not determine country. Please try again."
    }
};

export default class BlockOverlayComponent {
    render(container: HTMLElement, blockType: BlockType) {
        const { header, content } = BLOCK_CONFIGS_BY_TYPE[blockType];

        container.innerHTML = `
                <div class="bvp-block-overlay">
                    <div class="error-message">
                        <p class="error-header">${ header }</p>
                        <p>${ content }</p>
                    </div>
                </div>
            `;
    }
}
